<template>
    <!-- 修改手机号的对话框 -->
          <el-dialog
          title="修改手机号"
           :visible.sync="messageModifyDialogVisible"
          width="50%"
          @close="messageModifyDialogClosed">
          <el-form :rules="Rules"
          ref="messageModifyFormRef" label-width="90px" :model="formData">
              <el-form-item label="手机号" prop="phone" placeholder="请输入手机号">
                  <el-input v-model="formData.phone"></el-input>
              </el-form-item>
              <el-form-item label="验证码"  prop="verificationCode">
                    <el-input  v-model="formData.verificationCode" placeholder="请输入验证码">
                    <el-button slot="append" v-if="Verification" @click="getVerificationCode()">获取验证码</el-button>
                    <el-button slot="append" v-else-if="!Verification"><span>{{timer}}</span>秒后重新获取</el-button>
                    </el-input>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" @click="messageModifyPhone">确 定</el-button>
          </span>
          </el-dialog>
</template>

<script>
// import { verificationCodeButton } from '../components'
import * as api from '@/api/factory/central'
export default {
  components: { },
  data() {
    return {
      messageModifyDialogVisible: false,
      Verification: true,
      timer: 60, // 定义初始时间为60s
      autotimer: '',
      formData: {
        phone: '',
        verificationCode: ''
      },
      Rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$valid.checkPhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 展示修改手机号的弹框，外部调用
    show() {
      this.messageModifyDialogVisible = true
    },
    // 取消按钮
    cancel() {
      this.messageModifyDialogVisible = false
      this.$refs.messageModifyFormRef.resetFields()
    },
    // 根据短信验证码修改手机号
    messageModifyPhone() {
      this.$refs.messageModifyFormRef.validate(async valid => {
        if (!valid) return
        const data = {
            phone: this.formData.phone,
            verificationCode: this.formData.verificationCode
          }
        api.messageModifyPhone(data).then(res => {
          this.$message.success('修改手机号成功')
          // TODO 手机号修改之后，界面上的手机号并未修改
          this.messageModifyDialogVisible = false
        })
      })
    },
    // 获取验证码
    getVerificationCode () {
      if (this.validateAndtimer(this.formData) === true) {
        this.sendVerificationCode(this.formData.phone)
      }
    },
    // 获取验证码的请求
    sendVerificationCode () {
      const params = {
       phone: this.formData.phone
      }
      api.sendVerificationCode(params).then(res => {
        this.$message.success(`短信已发至手机${this.formData.phone}！`)
      })
    },
    // 验证手机号
    validateAndtimer(Form) {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (Form.phone === '') {
        this.$message.error('请输入手机号')
        return false
      }
      if (!regMobile.test(Form.phone)) {
        this.$message.error('手机号格式不正确，请重新输入')
        return false
      }
      this.Verification = false // 点击button改变v-show的状态
      this.autotimer = setInterval(() => { // 定时器设置每秒递减
        this.timer-- // 递减时间
        if (this.timer <= 0) {
          this.timer = 60
          this.Verification = true // 60s时间结束还原v-show状态并清除定时器
          clearInterval(this.autotimer)
        }
      }, 1000)
      return true
    }
  }
}
</script>

<style  scoped lang="scss">

</style>
